import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useNewRirekishoFormatData } from '@/composables/format-edit/useNewRirekishoFormatData'

type DateFormLib = {
  dateWithoutTime: (date: Date | string | null | undefined) => number | string
  getToday: () => Date
  getTommorow: () => Date
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRirekishoCreateDateCard',
  props: {
    currentCardId: null,
    formatId: null,
    isSendYagiPostEnabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  formatId?: string
  isSendYagiPostEnabled: boolean
};



const { formLib: formLibRaw, site, deviceLib } = useHostServices()
const formLib = formLibRaw as typeof formLibRaw & DateFormLib
const formatData = useNewRirekishoFormatData()
const activeName = ref('1')

const isTodaySelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getToday())
)

const isTomorrowSelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getTommorow())
)

function setToday() {
  formatData.createDate = formLib.getToday()
}

function setTomorrow() {
  formatData.createDate = formLib.getTommorow()
}

function onSendQuickEmail() {
  emitter.emit('send-special-quickemail', props.formatId)
}

return { __sfc: true,props, formLibRaw, site, deviceLib, formLib, formatData, activeName, isTodaySelected, isTomorrowSelected, setToday, setTomorrow, onSendQuickEmail }
}

})